import { Link } from "react-router-dom";
import { getStatus } from "./TasksHelper";
import { getTaskTypeName } from "@/utility/common";
import { useTranslation } from "react-i18next";

type ClaimsCell = {
  data: {
    claimId: String;
    claimReference: String;
  };
};
export const useTasksCustomCellRenderers = () => {
const {t}=useTranslation()
  const caseRenderers = {
    typeCellRenderer: function (param: any) {
      return <>{t(getTaskTypeName(param.data.type))}</>;
    },
    statusCellRenderer: function (param: any) {
        return <>{getStatus(param.data.status)}</>;
      },
    claimCellRenderer: function (param: ClaimsCell) {
      return (
        <>
          {
            <Link
              to={`./claim/${param.data.claimId}`}
              state={{ from: param.data.claimId }}
            >
             <span className="text-bold-underline">{ param.data.claimReference}</span> 
            </Link>
          }
        </>
      );
    },
  };
  return caseRenderers;
};
